import { useLocation } from '@reach/router';
import React, { ReactNode, forwardRef, useEffect } from 'react';
import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

interface IPageContainerProps {
	children: ReactNode;
	className?: string;
	footer?: ReactNode;
	header?: ReactNode;
}

const OuterContainer = styled(FlexColumn)`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;

	background: ${({ theme: components }) => components.pageContainer.background};
	display: flex;
	align-items: center;
	overflow-y: auto;
`;

const ChildrenContainer = styled.main`
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-grow: 1;
	width: 100%;
`;

const PageContainer = forwardRef<HTMLDivElement, IPageContainerProps>(
	({ className, children, footer, header }, ref) => {
		const location = useLocation();
		useEffect(() => {
			if (!window) {
				return;
			}
			const pageContainer = window?.document?.getElementById('pageContainer');
			if (!pageContainer) {
				return;
			}
			pageContainer.scrollTop = 0;
		}, [location]);
		return (
			<OuterContainer className={className} ref={ref} id="pageContainer">
				{!!header && header}
				<ChildrenContainer>{children}</ChildrenContainer>
				{!!footer && footer}
			</OuterContainer>
		);
	}
);

PageContainer.displayName = 'PageContainer';

export default styled(PageContainer)``;
